import type { PromptSnippet, PromptSnippetChatType, PromptSnippetInput } from "@/schema/prompt-snippet"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchPromptSnippets(
  context: ApiContext,
  options?: { scope?: "company" | "book"; chatType?: PromptSnippetChatType; includeSystem?: boolean }
) {
  const searchParams = new URLSearchParams()
  if (options?.scope) {
    searchParams.set("scope", options.scope)
  }
  if (options?.chatType) {
    searchParams.set("chat_type", options.chatType)
  }
  if (options?.includeSystem) {
    searchParams.set("include_system", "true")
  }

  const queryString = searchParams.toString()
  return apiContextFetch<{ prompt_snippets: PromptSnippet[] }>(
    context,
    `prompt_snippets${queryString ? `?${queryString}` : ""}`
  )
}

export function fetchPromptSnippet(context: ApiContext, id: string) {
  return apiContextFetch<PromptSnippet>(context, `prompt_snippets/${id}`)
}

export function createPromptSnippet(
  context: ApiContext,
  promptSnippet: PromptSnippetInput,
  options?: { scope?: "company" | "book" }
) {
  const params = options?.scope ? `?scope=${options.scope}` : ""
  return apiContextFetch<PromptSnippet>(context, `prompt_snippets${params}`, {
    method: "POST",
    body: JSON.stringify({ prompt_snippet: promptSnippet }),
  })
}

export function createPromptSnippetOverride(
  context: ApiContext,
  promptSnippet: PromptSnippetInput & { system_key: string; hidden?: boolean; scope?: "company" | "book" }
) {
  const { scope, ...attributes } = promptSnippet
  return apiContextFetch<PromptSnippet>(context, `prompt_snippet_overrides${scope ? `?scope=${scope}` : ""}`, {
    method: "POST",
    body: JSON.stringify({ prompt_snippet: attributes }),
  })
}

export function destroyPromptSnippetOverride(context: ApiContext, systemKey: string, id?: string) {
  const suffix = id ? `?id=${encodeURIComponent(id)}` : ""
  return apiContextFetch<void>(context, `prompt_snippet_overrides/${encodeURIComponent(systemKey)}${suffix}`, {
    method: "DELETE",
  })
}

export function updatePromptSnippet(context: ApiContext, id: string, promptSnippet: Partial<PromptSnippetInput>) {
  return apiContextFetch<PromptSnippet>(context, `prompt_snippets/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ prompt_snippet: promptSnippet }),
  })
}

export function destroyPromptSnippet(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `prompt_snippets/${id}`, {
    method: "DELETE",
  })
}
